import BulbOutlined from '@ant-design/icons/BulbOutlined';
import CommentOutlined from '@ant-design/icons/CommentOutlined';
import DiffOutlined from '@ant-design/icons/DiffOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import { useTranslation } from 'react-i18next';
import type { RunMode } from '@/api/runs';
import styles from './conversation.module.css';

/** The kit's dictionary names the modes normal, deep, compare and chat. */
export const MODE_KEYS: Record<RunMode, string> = {
  standard: 'v2.composer.mode_normal',
  thinking: 'v2.composer.mode_deep',
  comparison: 'v2.composer.mode_compare',
  chat_only: 'v2.composer.mode_chat',
};

/** The kit's mode icons (KIT_MODE_ICON). */
export const MODE_ICONS: Record<RunMode, typeof MessageOutlined> = {
  standard: MessageOutlined,
  thinking: BulbOutlined,
  comparison: DiffOutlined,
  chat_only: CommentOutlined,
};

/** Every answer's mode (spec §3); "Not recorded" when the message has none. */
const ModeBadge = ({ mode }: { mode: RunMode | string | null }) => {
  const { t } = useTranslation();
  const key = mode ? MODE_KEYS[mode as RunMode] : undefined;
  const Icon = mode ? MODE_ICONS[mode as RunMode] : undefined;
  return (
    <span
      className={styles.badge}
      data-testid="answer-mode"
      data-mode={mode ?? 'not-recorded'}
    >
      {Icon ? <Icon aria-hidden className={styles.badgeIcon} /> : null}
      {key
        ? t(key)
        : t('v2.composer.modeBtn', { m: t('v2.common.notRecorded') })}
    </span>
  );
};

export default ModeBadge;
